import { Select } from "components/ui/select/Select"
import type { TErefWithFurniture } from "types/elevationReferences.type"
import type { TQuotationComponentOption } from "types/quotations.type"
import type { TErefConfigurationSavePayload } from "../../useErefConfigurationSave"
import style from "./CountertopSeries.module.scss"

const { countertopSeries, label } = style

type Props = {
	eref: TErefWithFurniture
	save: (payload: TErefConfigurationSavePayload) => void
	isPending: boolean
	countertopOptions: TQuotationComponentOption[]
}

export const CountertopSeries = ({ eref, save, isPending, countertopOptions }: Props) => {
	const config = eref.estimation_config

	return (
		<div className={countertopSeries}>
			<span className={label}>Countertops series</span>
			<Select
				variant="outlined"
				options={countertopOptions.map((o) => ({ label: o.name, value: o.id }))}
				value={config?.countertop_series_and_colors_id ?? null}
				onChange={(v) => save({ countertop_series_and_colors_id: (v as number | undefined) ?? null })}
				disabled={isPending}
				allowClear={config?.countertop_series_and_colors_id == null}
				placeholder="Select countertop series"
				renderInPlace
			/>
		</div>
	)
}
